
import {
    SET_PRODUCT_TYPES
} from './action-types';

export function setProductTypes(payload:any) {
    return { type: SET_PRODUCT_TYPES, payload };
}